import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    try {
      return localStorage.getItem("hakan-admin-token") || null;
    } catch {
      return null;
    }
  });
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(!!token);

  const authHeaders = useCallback(() => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  }, [token]);

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("hakan-admin-token", data.token);
    setToken(data.token);
    setAdmin({ email: data.email });
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch {}
    localStorage.removeItem("hakan-admin-token");
    setToken(null);
    setAdmin(null);
  }, []);

  useEffect(() => {
    let ignore = false;
    if (!token) {
      setChecking(false);
      return;
    }
    (async () => {
      try {
        const { data } = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!ignore) setAdmin(data);
      } catch {
        if (!ignore) {
          localStorage.removeItem("hakan-admin-token");
          setToken(null);
          setAdmin(null);
        }
      } finally {
        if (!ignore) setChecking(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, admin, checking, login, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
